/* import __COLOCATED_TEMPLATE__ from './svg-icon.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'svg',
  attributeBindings: ['width', 'height', 'viewBox', 'fill', 'role', 'aria-hidden'],
  classNames: ['svg-icon'],
  classNameBindings: ['colorClass'],
  color: 'base',
  height: 28,
  width: 28,
  viewBox: '0 0 28 28',
  title: null,
  role: 'img',
  colorClass: computed('color', function () {
    return `svg-icon--theme-color-${this.get('color')}`;
  })
});